import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { FieldHandler } from '../auxiliary-data-table/auxiliary-data-table.interface';
import { UntypedFormGroup } from '@angular/forms';
import { AuxiliaryFieldHandlerService, LoadingStatus } from '../auxiliary-field-handler.service';
import { ObjectType } from '../schema-service/schema-interface';

@Component({
  selector: 'aux-auxiliary-data-panel',
  templateUrl: './auxiliary-data-panel.component.html',
  styleUrls: ['./auxiliary-data-panel.component.scss'],
  standalone: false,
})
export class AuxiliaryDataPanelComponent implements OnInit {
  @Input() partnerId = '';
  @Input() objectType: ObjectType;
  @Input() objectId = '';

  formGroup = new UntypedFormGroup({});
  LoadingStatus = LoadingStatus;

  loadingStatus$ = this.auxiliaryDataService.loadingStatus$;
  savingStatus$ = this.auxiliaryDataService.savingStatus$;

  fieldHandlers$!: Observable<FieldHandler[]>;

  constructor(private readonly auxiliaryDataService: AuxiliaryFieldHandlerService) {}

  ngOnInit(): void {
    this.auxiliaryDataService.init(this.partnerId, this.objectType, this.objectId, true);
    this.fieldHandlers$ = this.auxiliaryDataService.fieldHandlers$.pipe(
      tap((handlers) => {
        handlers.forEach((handler) => {
          this.formGroup.setControl(handler.fieldId, handler.formControl);
        });
      }),
    );
  }

  saveChanges(): Observable<boolean> {
    return this.auxiliaryDataService.saveChanges();
  }
}
